import React from 'react';
import { connect } from 'react-redux';
import {
  loadIpmaCisCreator,
  setIpmaCisPageCreator,
  setIpmaCisPerPageCreator,
  setIpmaCisSortCreator,
  setIpmaCisFiltersCreator,
  removeIpmaCisFiltersCreator,
  removeIpmaCisCreator,
  setIpmaCisProfileCreator,
} from 'store/actionsCreators';
import { isLoading } from 'helpers';
import CvmbReports from '../../../../shared/Cis/CvmbReports/CvmbReports';
import { loadGlobalCountriesCreator } from '../../../../store/actionsCreators';

const mapStateToProps = ({ loading, ipma, globals, user }) => ({
  loading: isLoading(loading, 'LOAD_IPMA_CIS'),
  type: 'ipma',
  list: ipma.cis.reports,
  countries: globals.countries,
  userPermissions: user.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  loadList: () => dispatch(loadIpmaCisCreator('reports')),
  setPage: (payload) => dispatch(setIpmaCisPageCreator('reports', payload)),
  setPerPage: (payload) => dispatch(setIpmaCisPerPageCreator('reports', payload)),
  setSort: (payload) => dispatch(setIpmaCisSortCreator('reports', payload)),
  setFilters: (payload) => dispatch(setIpmaCisFiltersCreator('reports', payload)),
  removeFilters: () => dispatch(removeIpmaCisFiltersCreator('reports')),
  removeReport: (payload) => dispatch(removeIpmaCisCreator('reports', payload)),
  setProfile: (payload) => dispatch(setIpmaCisProfileCreator('reports', payload)),
  loadCountries: () => dispatch(loadGlobalCountriesCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(CvmbReports);
